import clsx from 'clsx'
import React, {useState} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {useLocation} from 'react-router-dom'
import {MessageModel, UserInfoModel, defaultUserInfos} from '../../../../_metronic/helpers'
import {getUserData} from '../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import {PostComment} from '../../../Redux/AdminPanel/CommentSlice'
import {getAllUserDetails} from '../../UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'

const ChatModule = ({isDrawer, data}: any) => {
  const param: any = useLocation()
  const comment = useSelector((state: any) => state?.comment?.Comment?.data)

  const [chatUpdateFlag, toggleChatUpdateFlat] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [userInfos] = useState<UserInfoModel[]>(defaultUserInfos)
  const dispatch = useDispatch()

  const sendMessage = () => {
    dispatch(
      PostComment({
        userId: data?._id,
        comment: message,
      })
    )
    setMessage('')
  }

  const onEnterPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.keyCode === 13 && e.shiftKey === false) {
      e.preventDefault()
      sendMessage()
    }
  }

  const SigninUser = useSelector(getAllUserDetails)
  const acronymize = (inputString: any) => {
    // Split the input string by spaces
    const words = inputString.split(' ')

    // Initialize an empty string to store the acronym
    let acronym = ''

    // Iterate through the words and take the first letter of each word
    for (const word of words) {
      acronym += word[0].toUpperCase()
    }

    return acronym
  }
  return (
    <>
      <div
        className='card-body'
        id={true ? 'kt_drawer_chat_messenger_body' : 'kt_chat_messenger_body'}
      >
        <div
          className={clsx('scroll-y me-n5 pe-5', {'h-300px h-lg-auto': !true})}
          data-kt-element='messages'
          data-kt-scroll='true'
          data-kt-scroll-activate='{default: false, lg: true}'
          data-kt-scroll-max-height='auto'
          data-kt-scroll-dependencies={
            true
              ? '#kt_drawer_chat_messenger_header, #kt_drawer_chat_messenger_footer'
              : '#kt_header, #kt_toolbar, #kt_footer, #kt_chat_messenger_header, #kt_chat_messenger_footer'
          }
          data-kt-scroll-wrappers={
            true ? '#kt_drawer_chat_messenger_body' : '#kt_content, #kt_chat_messenger_body'
          }
          data-kt-scroll-offset={true ? '0px' : '-2px'}
        >
          {comment?.map((message: any, index: any) => {
            const userInfo = !message?.adminDetails?._id == SigninUser?._id

            console.log(message, 'cccccccccccccccccccc')

            const templateAttr = {}

            return (
              <div
                key={`message${index}`}
                className={clsx(
                  'd-flex',
                  'mb-10',
                  {'d-none': message.template},
                  {'flex-row-reverse': !userInfo}
                )}
                {...templateAttr}
              >
                <div
                  className={clsx(
                    'd-flex flex-column align-items',
                    `align-items-${userInfo ? 'start' : 'end'}`
                  )}
                >
                  {userInfo ? (
                    <>
                      <div className='d-flex align-items-center mb-2'>
                        <div className='symbol  symbol-35px symbol-circle '>
                          {/* <img alt='Pic' src={toAbsoluteUrl(`/media/${userInfo.avatar}`)} /> */}
                          <span className='circle1'>
                            {message?.adminDetails?.name
                              ? acronymize(message?.adminDetails?.name)
                              : ''}
                          </span>
                        </div>
                        <div className='ms-3'>
                          <a
                            href='#'
                            className='fs-5 fw-bolder text-gray-900 text-hover-primary me-1'
                          >
                            {message?.adminDetails?.name}
                          </a>
                          <span className='text-muted fs-7 mb-1'></span>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className='d-flex flex-row- align-items-center mb-2'>
                        <div className='me-3'>
                          <span className='text-muted fs-7 mb-1'></span>
                          <a
                            href='#'
                            className='fs-5 fw-bolder text-gray-900 text-hover-primary ms-1'
                          >
                            You
                          </a>
                        </div>
                        <div className='symbol  symbol-35px symbol-circle '>
                          {/* <img alt='Pic' src={toAbsoluteUrl(`/media/${userInfo.avatar}`)} /> */}

                          {/* <span className='circle1'>{`${message?.adminDetails?.firstName
                            ?.split('')[0]
                            .toUpperCase()}${
                            message?.adminDetails?.lastName !== undefined
                              ? message?.adminDetails?.lastName?.split('')[0].toUpperCase()
                              : ''
                          }`}</span> */}
                        </div>
                      </div>
                    </>
                  )}

                  <div
                    className={clsx(
                      'p-5 rounded',
                      `bg-light-${userInfo ? 'info' : 'primary'}`,
                      'text-dark fw-bold mw-lg-400px',
                      `text-${userInfo ? 'start' : 'end'}`
                    )}
                    data-kt-element='message-text'
                    // dangerouslySetInnerHTML={{__html: message.text}}
                  >
                    {message?.comment}
                  </div>
                </div>
              </div>
            )
          })}
        </div>

        <div
          className='card-footer pt-4'
          id={isDrawer ? 'kt_drawer_chat_messenger_footer' : 'kt_chat_messenger_footer'}
        >
          <textarea
            className='form-control form-control-flush mb-3'
            rows={1}
            data-kt-element='input'
            placeholder='Type a message'
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={onEnterPress}
          ></textarea>

          <div className='d-flex flex-stack'>
            <div className='d-flex align-items-center me-2'>
              <button
                className='btn btn-sm btn-icon btn-active-light-primary me-1'
                type='button'
                data-bs-toggle='tooltip'
                title='Coming soon'
              >
                <i className='bi bi-paperclip fs-3'></i>
              </button>
              <button
                className='btn btn-sm btn-icon btn-active-light-primary me-1'
                type='button'
                data-bs-toggle='tooltip'
                title='Coming soon'
              >
                <i className='bi bi-upload fs-3'></i>
              </button>
            </div>
            <button
              className='btn btn-primary'
              type='button'
              data-kt-element='send'
              onClick={sendMessage}
            >
              Send
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default ChatModule
